module.exports = __webpack_public_path__ + "static/media/feature8.a887ebbf.png";